import { useEffect, useState, forwardRef } from "react";
import Info from "../assets/icons/ic_info.svg";

const RadioGroup = forwardRef(
  (
    {
      label,
      name,
      options,
      selectedValue = "",
      onChange,
      error,
      disabled,
      required,
    },
    ref
  ) => {
    const [localValue, setLocalValue] = useState(selectedValue || "");

    useEffect(() => {
      setLocalValue(selectedValue || "");
    }, [selectedValue]);

    const handleChange = (e) => {
      const { value } = e.target;
      setLocalValue(value);
      onChange?.(e); // Optional chaining if onChange exists
    };

    return (
      <div className="mb-4" ref={ref}>
        {" "}
        {/* Ref attached here */}
        <label className="block text-inputColor text-sm font-normal mb-2">
          {label}
          {required && <span className="text-red-500 pl-1">*</span>}
        </label>
        <div className="flex flex-wrap gap-4">
          {options.map((option, index) => {
            // const normalized = option.trim();
            const value = option.value;
            const label = option.label;

            return (
              <label
                key={value}
                // className="inline-flex items-center text-sm font-medium text-activeTabColor cursor-pointer"
                className={`${
                  disabled
                    ? "text-gray-400 cursor-not-allowed"
                    : "text-activeTabColor cursor-pointer"
                } inline-flex items-center text-sm font-medium`}
              >
                <input
                  type="radio"
                  name={name}
                  value={value}
                  checked={localValue === value}
                  onChange={handleChange}
                  className="form-radio text-blue-600"
                  disabled={disabled}
                />
                <span className="ml-2">{label}</span>
              </label>
            );
          })}
        </div>
        {error && (
          <div className="flex gap-1 w-fit text-[10px] bg-red-100 text-red-600 mt-1 rounded p-[3px]">
            <img src={Info} alt="info" />
            {error}
          </div>
        )}
      </div>
    );
  }
);

export default RadioGroup;
